<template>
<section
  class="contact-panel">
  <BContainer
    class="content">
    <BRow
      class="my-1">

      <BCol
        lg="6"
        sm="12">
        <slot>
          Your stuff goes here
        </slot>
      </BCol>

      <BCol
        class="contact-form"
        lg="6"
        sm="12">

        <transition
          name="component-fade"
          mode="out-in">
          <BForm
            v-if="!submitted"
            @submit.stop="submitForm">
            <BFormGroup>
              <BFormInput
                v-model="formData.name"
                placeholder="Enter your name, e.g. chris@talloaks.io"
                :state="validName">
              </BFormInput>
            </BFormGroup>

            <BFormGroup>
              <BFormInput
                type="email"
                v-model="formData.email"
                placeholder="Enter your email address"
                :state="validEmail">
              </BFormInput>
            </BFormGroup>

            <BFormGroup
              v-if="!subject">
              <BFormSelect
                v-model="formData.subject"
                :options="subjects">
              </BFormSelect>
            </BFormGroup>

            <BFormGroup>
              <BFormCheckbox
                v-model="formData.subscribe">
                Subscribe to the newsletter
              </BFormCheckbox>
            </BFormGroup>

            <BFormGroup>
              <BFormTextarea
                v-model="formData.comments"
                placeholder="Tell us what you're looking for">
              </BFormTextarea>
            </BFormGroup>

            <BButton
              :disabled="!ready"
              type="button"
              :variant="ready ? 'primary' : null"
              @click.stop="submitForm">
              Submit
            </BButton>

          </Bform>
          <a v-else
             @click="submitStatus=null">
            <div class="alert">
              <h4>Thanks, we will be in touch</h4>
              <p>We will be sure to get back to you as soon as possible. In the meantime feel free to look around more!</p>
              <p>Cheers!</p>
              <p>Christian</p>
            </div>
          </a>
        </transition>

      </BCol>

    </BRow>

  </BContainer>
</section>
</template>

<script>
import { mapActions } from 'vuex'
import { post } from '@/api';
import {
  BContainer,
  BForm,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BFormTextarea,
  BFormSelect,
  BButton,
  BAlert,
} from 'bootstrap-vue'

//const RECAPTCHA_TOKEN = '6LeS8KkUAAAAAFlzcminqeoZOlA5ESD2k6ww6K8G';

const subjects = [
  { value: null, text: 'Please select an option' },
  { value: 'ouzel' , text: 'Ouzel Land Management Application' },
  { value: 'acorns' , text: 'ACORNS Environmental Data Platform' },
  { value: 'aermod' , text: 'AERMOD Model Builder Application' },
  { value: 'other' , text: 'Something else entirely' },
];

export default {
  name: 'ContactPanel',
  props: {
    subject: String,
  },
  data() {
    return {
      submitting: false,
      submitStatus: null,
      formData: {
        name: null,
        email: null,
        subject: null,
        comments: null,
        subscribe: false,
      }
    };
  },
  components: {
    'b-alert': BAlert,
    'b-container': BContainer,
    'b-row': BRow,
    'b-col': BCol,
    'b-form-input': BFormInput,
    'b-form-checkbox': BFormCheckbox,
    'b-form-textarea': BFormTextarea,
    'b-form-select': BFormSelect,
    'b-form-group': BFormGroup,
    'b-form': BForm,
    'b-button': BButton,
  },
  created() {
    if(this.subject){
      this.formData.subject = this.subject;
    }
  },
  watch: {},
  computed: {
    ready(){
      return this.validEmail && this.validName;
    },
    submitted(){
      return !this.submitting && this.submitStatus == 'SUBMITTED';
    },
    validName(){
      if(!this.formData.name) return null;
      return this.formData.name.length>1;
    },
    validEmail(){
      if(!this.formData.email) return null;
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.formData.email)
    },
    subjects(){
      return subjects;
    }
  },
  methods: {
  ...mapActions([
      'pageEvent'
  ]),
    // recaptchaToken() {
    //   return new Promise((resolve) => {
    //     grecaptcha.ready(async () => {
    //       const token = await grecaptcha.execute(RECAPTCHA_TOKEN);
    //       resolve(token);
    //     });
    //   });
    // },
    async submitForm(){
      //const url = 'https://api.github.com/users/caparker';
      const url = 'mailto';
      const data = this.formData;

      this.submitting = true;
      this.submitStatus = 'PENDING';

      //const token = await this.recaptchaToken()

      await post(url, { ...data })
        .then(() => {
          this.submitStatus = 'SUBMITTED';
          this.pageEvent({
            label: `contact-form:${this.formData.subject}`,
          })
          this.formData = {
            name: null,
            email: null,
            subject: this.subject,
            comments: null
          }
        })
        .catch( () => {
          this.submitStatus = 'ERROR';
        })
        .finally( () => {
          this.submitting = false;
        });

      // do something great
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~@/styles/variables';
.contact-panel  {
  padding: 5rem 0;
  background-color: #e9ecef;
  .content {
    margin: 0 auto;
    max-width: 60rem;
  }

  .contact-form {
    min-height: 17.5rem;
    padding: 0 2rem;
    .alert {
      cursor: pointer;
    }
  }

  .component-fade-enter-active, .component-fade-leave-active {
    transition: opacity .3s ease;
  }
  .component-fade-enter, .component-fade-leave-to
  /* .component-fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
}
</style>
